import React from 'react';
import PropTypes from 'prop-types';
import PanelClaro from 'newComponents/PanelClaro/PanelClaro';
import Active from './forms/Active';
import NotActive from './forms/NotActive';
import Remind from './forms/Remind';
import Change from './forms/Change';
import Desactive from './forms/Desactive';
import Default from './forms/Default';
import {
  ACTIVE,
  CHANGE,
  DESACTIVE,
  MODIFY,
  REMIND,
  NOT_ACTIVE,
  DEFAULT,
} from './constants';

const ControlPin = ({
  infoPin,
  isActive,
  typeForm,
  label,
  form,
  errors,
  loading,
  onSendMetrics,
  onSave,
  onChange,
  onToggle,
}) => {
  const renderForm = () => {
    let toRender = null;
    switch (typeForm) {
      case ACTIVE:
      case MODIFY:
        onSendMetrics();
        toRender = (
          <Active
            isActive={isActive}
            label={label.active}
            labelBtn={label.btn}
            errors={errors}
            form={form}
            onToggle={onToggle}
            onChange={onChange}
            onSave={onSave}
            loading={loading}
          />
        );
        break;
      case CHANGE:
        toRender = (
          <Change
            label={label.change}
            labelBtn={label.btn}
            errors={errors}
            form={form}
            onToggle={onToggle}
            onChange={onChange}
            onSave={onSave}
            loading={loading}
          />
        );
        break;
      case DESACTIVE:
        toRender = (
          <Desactive
            label={label.desactive}
            labelBtn={label.btn}
            errors={errors}
            form={form}
            onToggle={onToggle}
            onChange={onChange}
            onSave={onSave}
            loading={loading}
          />
        );
        break;
      case REMIND:
        toRender = (
          <Remind
            label={label.remind}
            labelBtn={label.btn}
            onToggle={onToggle}
            onSave={onSave}
            loading={loading}
          />
        );
        break;
      case NOT_ACTIVE:
        toRender = (
          <NotActive
            label={label.notActive}
            labelBtn={label.btn}
            onToggle={onToggle}
          />
        );
        break;
      case DEFAULT:
        toRender = (
          <Default
            infoPin={infoPin}
            label={label.default}
            labelBtn={label.btn}
            onToggle={onToggle}
          />
        );
        break;
      default:
        toRender = null;
    }
    return toRender;
  };
  return (
    <>
      <PanelClaro sectionName="micuentacontrolpin">{renderForm()}</PanelClaro>
    </>
  );
};

ControlPin.propTypes = {
  infoPin: PropTypes.object,
  isActive: PropTypes.bool,
  typeForm: PropTypes.string,
  label: PropTypes.object,
  form: PropTypes.object,
  errors: PropTypes.object,
  loading: PropTypes.bool,
  onSendMetrics: PropTypes.func,
  onChange: PropTypes.func,
  onToggle: PropTypes.func,
  onSave: PropTypes.func,
};
export default ControlPin;
